import { render, staticRenderFns } from "./withholdIdol.vue?vue&type=template&id=1ea3336f&scoped=true"
import script from "./withholdIdol.vue?vue&type=script&lang=ts"
export * from "./withholdIdol.vue?vue&type=script&lang=ts"
import style0 from "./withholdIdol.vue?vue&type=style&index=0&id=1ea3336f&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea3336f",
  null
  
)

export default component.exports